module.exports = "<div id=\"{{ $ctrl.verticalBarChartId }}\"></div>";